<template>
  <div v-loading="loading" class="quick-entrance">
    <title-item @change="handleChange">
      <div class="info-card-title mb-0">
        常用入口
      </div>
    </title-item>

    <el-scrollbar v-if="list.length > 0" class="max-h-[296px] mt-4" :always="false">
      <div class="quick-entrance-list">
        <div v-for="(v, idx) in list" :key="idx" class="quick-entrance-list-item" @click="handleClick(v)">
          <img :src="`${homePageCosUrl}${v.imgSrc}`" alt="">
          <div class="title">
            {{ v.name }}
          </div>
        </div>
      </div>
    </el-scrollbar>
    <el-empty
      v-else
      class="w-full flex justify-center items-center p-0"
      description="暂无常用入口"
      :image-size="80"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import TitleItem from '../widgets/TitleItem.vue';
import { useRouter } from 'vue-router';
import { queryCommonEntranceList } from '@core/main/api';
import { ElMessage } from 'element-plus';
import { homePageCosUrl, ICommonEntry } from '@core/main/types';

const router = useRouter(); 

const loading = ref(false);
const list = ref<ICommonEntry[]>([]);

function handleChange() {
  router.push({ name: 'CommonEntrancesManage' });
}

function handleClick(v: ICommonEntry) {
  router.push({ name: v.routeName });
}

async function fetchData() {
  loading.value = true;
  try {
    const { addedEntries } = await queryCommonEntranceList();

    list.value = addedEntries || [];
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
  loading.value = false;
}

fetchData();
</script>

<style lang="scss" scoped>
.quick-entrance {
  @apply w-full p-3 bg-white rounded-sm;

  .quick-entrance-list {
    @apply w-full flex flex-wrap gap-y-[12px] gap-x-2;

    .quick-entrance-list-item {
      @apply w-[82px] flex flex-col items-center justify-center cursor-pointer;

      img {
        @apply w-[36px] h-[36px];
      }

      .title {
        @apply text-[12px] text-[#595959] mt-2 w-full text-center truncate;
      }
    }

  }
}
</style>
